import React from 'react';
import PropTypes from 'prop-types';

import List from '@material-ui/core/List';

import GroupSetListItem from './GroupSetListItem.container';
import GroupSetsLoader from './GroupSetsLoader';
import NoGroupsPlaceholder from './NoGroupsPlaceholder.container';
import { GroupsListContainer, GroupList } from './GroupSetsList.styled';
import Scrollbar from '../../common/ScrollBar';

const GroupSetsList = ({ loading, sets }) => {
  if (loading) {
    return <GroupSetsLoader />;
  }

  if (sets.length === 0) {
    return <NoGroupsPlaceholder />;
  }

  return (
    <GroupsListContainer>
      <Scrollbar autoHide>
        <GroupList>
          <List>
            {sets.map((setId) => (
              <GroupSetListItem key={setId} set={setId} />
            ))}
          </List>
        </GroupList>
      </Scrollbar>
    </GroupsListContainer>
  );
};

GroupSetsList.propTypes = {
  loading: PropTypes.bool.isRequired,
  sets: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GroupSetsList;
